import { get } from 'lodash';
import { OwnershipReasonEnum } from '../enum/ownership-reason.enum';
import { Owner } from '../polymer/Owner.model';
import { Occupier } from '../polymer/Occupier.model';
import { MopCheckStatusEnum } from '../enum/mop-check-status.enum';
import { DemiseAdministratorDoc } from '../enum/demise-administrator-doc.enum';


export class ApplicationStep1 {
  reason    : ReasonFormData;
  household : HouseholdFormData;


  constructor(initial?:any){
    this.reason    = get(initial,'reason',new ReasonFormData());
    this.household = get(initial,'household',new HouseholdFormData());
  }
}

export class HouseholdFormData{
  owners             :Owner[];
  occupiers          :Occupier[];
  incoming_owners    :Owner[];
  incoming_occupiers :Occupier[];
  
  check_has_private_property : boolean | undefined ;
  check_has_dispose_property : boolean | undefined ;
    
  constructor(initial?:any){
    let tempOwners            = get(initial, 'owners',             []);
    let tempOccupier          = get(initial, 'occupiers',          []);
    let tempIncomingOwners    = get(initial, 'incoming_owners',    []);
    let tempIncomingOccupiers = get(initial, 'incoming_occupiers', []);
    this.owners               = [...tempOwners.map((e:Owner)=> { return new Owner(e)})];
    this.occupiers            = [...tempOccupier.map((e:Owner)=> { return new Owner(e)})];
    this.incoming_owners      = [...tempIncomingOwners.map((e:Owner)=> { return new Owner(e)})];
    this.incoming_occupiers   = [...tempIncomingOccupiers.map((e:Occupier)=> { return new Occupier(e)})];
    
    this.check_has_private_property = get(initial, 'check_has_private_property', undefined);
    // Question removed from UI (2026-07-28); new apps stay undefined (null in DB). Legacy loads preserve true/false.
    this.check_has_dispose_property = get(initial, 'check_has_dispose_property', undefined);
  }
}


export class ReasonFormData {
  reason                         : string;
  change_ownership_reason        : OwnershipReasonEnum;
  have_final_judgement           : string;
  final_judgement_date           : string;
  has_outstanding_loan           : string;
  outstanding_loan_amount        : string;

  date_of_marriage               : string; //Divorce or Owner moving out
  date_of_court_order            : string; //Divorce
  amount_stated_in_court_order   : string; //Divorce
  cpf_refund                     : string; //Divorce
  submit_content                 : boolean | undefined; //Divorce
  registrar_uinfin               : string; //Divorce

  has_administration_items       : DemiseAdministratorDoc | undefined; //Demise
  death_date                     : string; //Demise
  is_beneficiary_proposed_owners : string; //Demise
  validation_exempted_fields     : string[];//Demise

  date_of_renunciation              : string; // Loss of ownership

  check_mop_status               : MopCheckStatusEnum | undefined;
  check_loan_status              : boolean | undefined ;
  check_cdb_status               : boolean | undefined ;
  
  
  
  constructor(initial?:any){
    this.reason                         = get(initial, 'reason',                         '');
    this.change_ownership_reason        = get(initial, 'change_ownership_reason',        '');
    this.have_final_judgement           = get(initial, 'have_final_judgement',           '');
    this.final_judgement_date           = get(initial, 'final_judgement_date',           '');
    this.has_outstanding_loan           = get(initial, 'has_outstanding_loan',           '');
    this.outstanding_loan_amount        = get(initial, 'outstanding_loan_amount',        '');

    this.date_of_marriage               = get(initial, 'date_of_marriage',               '');
    this.date_of_court_order            = get(initial, 'date_of_court_order',            '');
    this.amount_stated_in_court_order   = get(initial, 'amount_stated_in_court_order',   '');
    this.cpf_refund                     = get(initial, 'cpf_refund',                     '');
    this.submit_content                 = get(initial, 'submit_content',                 undefined);
    this.registrar_uinfin     = get(initial, 'registrar_uinfin',                     '');

    this.has_administration_items       = get(initial, 'has_administration_items',       undefined);
    this.death_date                     = get(initial, 'death_date',                     '');
    this.is_beneficiary_proposed_owners = get(initial, 'is_beneficiary_proposed_owners', '');
    this.validation_exempted_fields     = get(initial, 'validation_exempted_fields', []);
    
    this.date_of_renunciation           = get(initial, 'date_of_renunciation',              '');
    
    this.check_mop_status               = get(initial, 'check_mop_status',               undefined);
    this.check_loan_status              = get(initial, 'check_loan_status',              undefined);
    this.check_cdb_status               = get(initial, 'check_cdb_status',               undefined);

  }
}
